import { create } from "zustand";
import { persist } from "zustand/middleware";
import {
  ConnectionMode,
  DateSelectorMode,
  FlightSearchData,
  initialFlightSearchData,
  TripType,
} from "../models/flightSearchData";
import { TravelDuration } from "../models/TravelDuration";

interface FlightSearchStore {
  data: FlightSearchData;
  setData: (data: FlightSearchData) => void;
}

export const useFlightSearchStore = create<FlightSearchStore>()(
  persist(
    (set) => ({
      data: initialFlightSearchData,
      setData: (data) => set({ data }),
    }),
    {
      name: "flight-search-storage",
      merge: (persisted, current) => {
        const state = persisted as FlightSearchStore;
        const persistedTravelDuration = state.data.travelDuration as TravelDuration | "one-way" | undefined;
        const migratedFromOneWayDuration = persistedTravelDuration === "one-way";

        return {
          ...current,
          ...state,
          data: {
            ...initialFlightSearchData,
            ...state.data,
            dateFrom: state.data.dateFrom
              ? new Date(state.data.dateFrom)
              : initialFlightSearchData.dateFrom,
            dateTo: state.data.dateTo ? new Date(state.data.dateTo) : initialFlightSearchData.dateTo,
            categories: state.data.categories?.length
              ? state.data.categories
              : initialFlightSearchData.categories,
            departureCountries: state.data.departureCountries ?? initialFlightSearchData.departureCountries,
            destinationAirports: state.data.destinationAirports ?? initialFlightSearchData.destinationAirports,
            destinationCountries: state.data.destinationCountries ?? initialFlightSearchData.destinationCountries,
            tripType: state.data.tripType || (migratedFromOneWayDuration ? TripType.OneWay : TripType.RoundTrip),
            travelDuration: migratedFromOneWayDuration
              ? TravelDuration.MEDIUM
              : persistedTravelDuration || TravelDuration.MEDIUM,
            minDurationDays: state.data.minDurationDays ?? initialFlightSearchData.minDurationDays,
            maxDurationDays: state.data.maxDurationDays ?? initialFlightSearchData.maxDurationDays,
            connectionMode: state.data.connectionMode || ConnectionMode.Direct,
            dateSelectorMode:
              state.data.dateSelectorMode || DateSelectorMode.Timeline,
          },
        };
      },
    }
  )
);
